var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddParticiapants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.783,
    height: 16.302,
    viewBox: "0 0 19.783 16.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5956,146.3v-3.713c0-2.4,2.1-4.334,7.194-4.334s7.193,1.938,7.193,4.334V146.3Zm15.287-6.411v-2.7h-2.7v-1.8h2.7v-2.7h1.8v2.7h2.7v1.8h-2.7v2.7ZM5959.6,133.6a3.6,3.6,0,1,1,3.6,3.6A3.6,3.6,0,0,1,5959.6,133.6Z",
    transform: "translate(-5956 -130.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddParticiapants);
export default __webpack_public_path__ + "static/media/addParticiapants.7af97b772686f334c09810eff41c42d1.svg";
export { ForwardRef as ReactComponent };